import { Injectable, inject, effect } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Global } from '@services/core/Global';
import { MicrosoftAuthService } from '@services/core/authentication.service';

@Injectable()
export class AddPartyService {
  public url: string;
  public url_declaracion: string;
  public identity;


  constructor(
    private _http: HttpClient,
    private _microsoftAuth: MicrosoftAuthService
  ) {
    this.url = Global.url;
  }



  protected convertToFilter(objeto): HttpParams {
    let params = new HttpParams();
    const hasKeys = Object.keys(objeto)?.length > 0;
    if (hasKeys != null || hasKeys != undefined) {
      params = this.createKeys(objeto, params);
    }
    return params;
  }

  protected createKeys(objeto, params) {
    for (const clave in objeto) {
      if (objeto[clave] != null || objeto[clave] != undefined) {
        params = params.append(clave, objeto[clave]);
      }
    }
    return params;
  }

  /**crea la url pasandole los parametros ej. {id:1,rut:15} reuturn '1/15 */
  buildUrl(params) {
    let queryParams = '';
    if (params) {
      queryParams = Object.keys(params)
        .map((key) => `${params[key]}`)
        .join('/');
    }
    return queryParams ? `${queryParams}` : '';
  }

  createParty(formData) {
    return this._http.post(this.url + 'V1/parties', formData);
  }

  createVehicle(formData) {
    return this._http.post(this.url + 'V1/vehicles', formData);
  }

  getDocumentView(params) {
    return this._http.get(this.url + 'V1/documents-view', { params: this.convertToFilter(params) });
  }

  uploadDocument(uuid, file: File, expirationDate?: string | null) {
    const formData = new FormData();
    formData.append('file', file);
    if (expirationDate) formData.append('expirationDate', expirationDate);
    return this._http.put(`${this.url}V1/documents/upload/${uuid}`, formData);
  }

  createDocumentBulk(formData) {
    return this._http.post(this.url + 'V1/documents-bulk', formData);
  }

  updateParty(uuid: string, formData: any) {
    return this._http.put(this.url + 'V1/party/' + uuid, formData);
  }

  updateVehicle(uuid: string, formData: any) {
    return this._http.put(this.url + 'V1/vehicles/' + uuid, formData);
  }

  updateRequest(uuid: string, formData: any) {
    return this._http.put(this.url + 'V1/requests/' + uuid, formData);
  }

  deleteRequest(uuid: string) {
    return this._http.delete(this.url + 'V1/requests/' + uuid);
  }

  /** Soft-discard del borrador (DISCARDED). Hard-delete queda para soporte. */
  discardRequest(uuid: string) {
    return this._http.post(this.url + 'V1/requests/' + uuid + '/discard', {});
  }

  /** Reactiva solicitud DISCARDED → paso inicial (DRAFT). */
  reactivateRequest(uuid: string) {
    return this._http.post(this.url + 'V1/requests/' + uuid + '/reactivate', {});
  }

  /** Materializa un documento complementario (activo no obligatorio) desde el snapshot. */
  addDocumentFromSnapshot(body: {
    requestUuid?: string;
    requestId?: number;
    typeSlug: string;
    ownerSlug?: string;
    vehicleId?: number;
  }) {
    return this._http.post(this.url + 'V1/request-documents/from-snapshot', body);
  }

  deleteRequestDocument(uuid: string) {
    return this._http.delete(this.url + 'V1/request-documents/' + uuid);
  }

}